import type { AppLinkProps } from '@/hooks/usePathHelper'
import type { RecoverablePosCartSummary } from '@/lib/services/carts/carts.types'
type OrgId = string | number

// The sales-order create path and link supplied by usePathHelper.
interface SalesOrderCreatePath {
  salesOrders: {
    create: () => { using: (params: { orgId: OrgId }) => { link: AppLinkProps } }
  }
}

// Reopening a POS cart replaces the create page's search so stale filters never follow staff in.
export function getPosCartResumeLink(
  path: SalesOrderCreatePath,
  { orgId, cartId }: { orgId: OrgId; cartId: RecoverablePosCartSummary['latest_cart_id'] }
): AppLinkProps {
  return {
    ...path.salesOrders.create().using({ orgId }).link,
    search: { cartId },
  }
}
